import React from "react";

import {
  CompassHero,
  Hero,
  Skeleton
} from "@patternfly/react-core";

import "../../home/heroes/HomeHero.css";

const AnnouncementHeroSkeleton = () => {
  return (
    <CompassHero className="school-home-hero-wrapper">
      <Hero
        isGlass
        className="school-home-hero school-announcement-hero"
        bodyWidth="100%"
        bodyMaxWidth="100%"
      >
        <div className="school-home-hero__layout">
          <div className="school-home-hero__content">
            <div className="school-home-hero__meta">
              <Skeleton width="5rem" />
              <Skeleton width="7rem" />
            </div>
            <br />
            <div className="school-home-hero__title">
              <Skeleton
                width="75%"
                fontSize="2xl"
              />
            </div>

            <div className="school-home-hero__excerpt">
              <Skeleton width="100%" />
              <Skeleton width="85%" />
              <Skeleton width="65%" />
            </div>

            <div className="school-home-hero__spacer" />
            <br />
            <Skeleton
              width="7rem"
              height="2.25rem"
            />

          </div>

          <div className="school-home-hero__media school-home-hero__media--square">
            <Skeleton
              width="100%"
              height="100%"
            />
          </div>
        </div>
        
        <div className="school-home-hero__footer">
          <Skeleton
            width="30%"
            height="2rem"
            style={{ marginInline: "auto" }}
          />
        </div>
      </Hero>
    </CompassHero>
  );
};

export default AnnouncementHeroSkeleton;